import React from "react";
import { Container, Grid2, Typography, IconButton, Box } from "@mui/material";
import { Facebook, Twitter, LinkedIn, Instagram } from "@mui/icons-material";
import "./style.css";
import "./footerStyle.css";
const Footer = ({ data }) => {
  const goUrl = (url) => {
    window.open(url, "_blank");
  };

  const date = new Date()
  const year = date.getFullYear()

  return (
    <div className="footer-containere">
      <div className="contact-area" id="contact">
        <div className="">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <div
                className="contact-content text-center"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <a href="#" style={{ textAlign: "center" }}>
                  <img src={data.app_logo} alt="logo" />
                </a>
                <p style={{ color: "#fff" }}>
                  <span className={"taglines"} style={{ color: "#fff" }}>
                    Right property
                  </span>
                  &nbsp;
                  <span className={"taglines"} style={{ color: "#fff" }}>
                    Right place{" "}
                  </span>
                  &nbsp;
                  <span className={"taglines"} style={{ color: "#fff" }}>
                    Right price
                  </span>
                </p>
                <p style={{ marginTop: "-8x" }}>{data.footer_description}</p>
                <div className="hr"></div>
                <h6>{data.header_email}</h6>
                <h6>
                  {data.header_phone}
                  <span>|</span>
                  {data.header_phone2}
                </h6>
                <div className="contact-social">
                  <ul>
                    <li>
                      <a
                        className="hover-target"
                        href="#"
                        onClick={() => goUrl(data.social_fb)}
                      >
                        <Facebook />
                      </a>
                    </li>
                    <li>
                      <a
                        className="hover-target"
                        href="#"
                        onClick={() => goUrl(data.social_twitter)}
                      >
                        <Twitter />
                      </a>
                    </li>
                    <li>
                      <a
                        className="hover-target"
                        href="#"
                        onClick={() => goUrl(data.social_linkedin)}
                      >
                        <LinkedIn />
                      </a>
                    </li>
                    <li>
                      <a
                        className="hover-target"
                        href="#"
                        onClick={() => goUrl(data.social_instagram)}
                      >
                        <Instagram />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer_">
        <p>
          Copyright &copy; {year}  </p>
        <p>
          <img src={data.app_logo} alt="logo" />
        </p>
        <p>  All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
